import { ReduxAction } from 'actions';
import { AdminProductCategoryList_adminProductCategories } from '@api/graphql/types';
import {
    ProductCategoryActionType, UpdateProductCategoryListType,
} from '@actions/productCategoryActions';
import { AuthActionType } from '@actions/authActions';

export type ProductCategoriesReducer = AdminProductCategoryList_adminProductCategories[];

const initialState: ProductCategoriesReducer = [];

export default function (state: ProductCategoriesReducer = initialState, reduxAction: ReduxAction) {
    switch (reduxAction.type) {
        case ProductCategoryActionType.updateProductCategoryList:
            return {...(reduxAction as UpdateProductCategoryListType).productCategories};
        case AuthActionType.logout:
            return initialState;
        default:
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/productCategoryReducer.ts